import React from 'react'

import { InlineFilterNumberValueInput } from '../../InlineFilterNumberValueInput'

import type { InlineFilterInputComponent } from './types'

export const NumberInput: InlineFilterInputComponent<{}> = ({ value, ...props }) => {
    return <InlineFilterNumberValueInput value={value as string | number | undefined} {...props} />
}
